import { render } from "./IconMic.vue?vue&type=template&id=1fc0df68"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconMic.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1fc0df68"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1fc0df68', __exports__)) {
    api.reload('1fc0df68', __exports__)
  }
  
  module.hot.accept("./IconMic.vue?vue&type=template&id=1fc0df68", () => {
    api.rerender('1fc0df68', render)
  })

}


export default __exports__